import React from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCloudDocumentAction } from "./actions";
import { Row, Col, Tabs } from 'antd';
import { useState } from "react";
import FundDeck from "@hedgefund/shared/src/FundDeck";
import { Spinner } from "@public/ui-toolkit";


const CloudDocuments = [
  {
    name: "All Document",
    key: null
  },
  {
    name: "Presentation",
    key: 0
  },
  {
    name: "Investor Letters",
    key: 1
  },
  {
    name: "Firm Research",
    key: 2
  },
  {
    name: "Due Diligence Document",
    key: 3
  }
]
const CloudDocument = ({ match }) => {
  const [activeTab, setActiveTab] = useState();
  const getCloudDocumentState = useSelector((state) => state.CloudDocumentStore);
  const { loading, getDocuments } = getCloudDocumentState;
  const dispatch = useDispatch();
  const hedgeFundId = match.params.id;

  useEffect(() => {
    getCloudDocuments(null);
  }, []);

  const getCloudDocuments = (DocType) => {
    dispatch(getCloudDocumentAction({
      recordId: hedgeFundId,
      recordType: 1,
      docType: DocType
    }));
  }
  const onClickTab = (tabId) => {
    getCloudDocuments(tabId);
    setActiveTab(tabId);
  }

  return (
    <main className="main-doc">
      <div className="main-inner">
        {!loading ? (
          <div className="container mt-3">
            <div>
              <Row className="border"
                style={{
                  minHeight: "300px",
                  background: "#ffff",
                  padding: "10px",  
                  borderRadius: "10px",
                  width: "100%",
                }}>
                <Col span={24} >
                  <div className="Fund-FontSize" style={{ fontSize: "20px",padding: "10px" }}>Fund Document Cloud</div>
                </Col>
                <Col span={24}>
                <Tabs
                  activeKey={activeTab}
                  className="custom-tabs"
                  size="large"
                  onTabClick={(e) => onClickTab(e)}
                  type="card"
                  items={CloudDocuments?.map((item, index) => {
                    return {
                      label: item.name,
                      key: item.key,
                      children:
                          <FundDeck
                            portal="Allocator"
                            decks={getDocuments}
                          />
                    };
                  })}
                />
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </main>
  );
};

export default CloudDocument;
